import React from 'react';
import PropTypes from 'prop-types';

const EyeOff = ({ color = '#8C949C' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12">
        <g fill="none" fillRule="evenodd">
            <path
                fill={color}
                fillRule="nonzero"
                d="M10.0010877,0.699999988 C6.1809123,0.699999988 2.76669009,2.72834713 0.5,5.91334665 C2.76669009,9.09854885 6.1809123,11.1266933 10.0010877,11.1266933 C13.8210604,11.1266933 17.2354853,9.09854885 19.5021754,5.91334665 C17.2354853,2.72834713 13.8210604,0.699999988 10.0010877,0.699999988 Z M10.0012903,9.32473145 C8.11724609,9.32473145 6.58970288,7.79759359 6.58970288,5.91334665 C6.58970288,4.02909972 8.11724609,2.50196186 10.0012903,2.50196186 C11.8853346,2.50196186 13.4120671,4.02909972 13.4120671,5.91334665 C13.4120671,7.79759359 11.8853346,9.32473145 10.0012903,9.32473145 Z M10.0010877,3.50032697 C8.66851549,3.50032697 7.58806799,4.58077447 7.58806799,5.91334665 C7.58806799,7.24612151 8.66851549,8.32636634 10.0010877,8.32636634 C11.3338625,8.32636634 12.4141074,7.24612151 12.4141074,5.91334665 C12.4141074,4.58077447 11.3338625,3.50032697 10.0010877,3.50032697 Z"
            />
            <path stroke={color} strokeLinecap="round" strokeWidth="2" d="M1,11 L19,1" />
        </g>
    </svg>
);

EyeOff.propTypes = {
    color: PropTypes.string,
};

export default EyeOff;
